import { render, staticRenderFns } from "./UserInfoSvg.vue?vue&type=template&id=1826a12c"
import script from "./UserInfoSvg.vue?vue&type=script&lang=js"
export * from "./UserInfoSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports